<div class="c-field" [formGroup]="group">
  <app-formelementinputlabel [config]="config" [group]="group">
  </app-formelementinputlabel>
  <app-forminputnumber [config]="config" [group]="group"
                 [formControlName]="config.ClientId" class="o-input"
                 #formInput></app-forminputnumber>
  <app-formelementinputdescription [config]="config" [group]="group">
  </app-formelementinputdescription>
  <app-formelementinput-validationmessages [config]="config" [group]="group">
  </app-formelementinput-validationmessages>
</div>
